import i18n from "@/i18n/config"
import { EventHandlerConfig } from "@/widgetLibrary/interface"

export const EVENT_CALENDAR_EVENT_HANDLER_CONFIG: EventHandlerConfig = {
  events: [
    {
      label: i18n.t(
        "editor.inspect.setter_content.widget_action_type_name.change",
      ),
      value: "change",
    },
    {
      label: i18n.t(
        "editor.inspect.setter_content.widget_action_type_name.select",
      ),
      value: "select",
    },
    {
      label: i18n.t(
        "editor.inspect.setter_content.widget_action_type_name.DragOrClickNoEventArea",
      ),
      value: "DragOrClickNoEventArea",
    },
  ],
  methods: [],
}
